'use client';
import React from 'react';
import { TrendingUp, TrendingDown, CalendarCheck, Clock, Star, Users } from 'lucide-react';

const kpis = [
  {
    id: 'kpi-occupancy',
    label: 'Occupancy Rate',
    value: '78%',
    subtext: 'May 2026',
    trend: '+6% vs last month',
    trendUp: true,
    icon: CalendarCheck,
    iconBg: 'bg-primary/10',
    iconColor: 'text-primary',
    cardBg: 'bg-white',
    featured: true,
  },
  {
    id: 'kpi-revenue',
    label: 'Revenue (MTD)',
    value: '€8,420',
    subtext: 'Month to date',
    trend: '+12% vs April',
    trendUp: true,
    icon: TrendingUp,
    iconBg: 'bg-secondary/10',
    iconColor: 'text-secondary',
    cardBg: 'bg-white',
    featured: false,
  },
  {
    id: 'kpi-pending',
    label: 'Pending Bookings',
    value: '3',
    subtext: 'Awaiting approval',
    trend: 'Action required',
    trendUp: false,
    icon: Clock,
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
    cardBg: 'bg-amber-50 border-amber-200',
    featured: false,
    alert: true,
  },
  {
    id: 'kpi-checkins',
    label: 'Upcoming Check-ins',
    value: '5',
    subtext: 'Next 7 days',
    trend: 'Next: 16 May',
    trendUp: true,
    icon: CalendarCheck,
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600',
    cardBg: 'bg-white',
    featured: false,
  },
  {
    id: 'kpi-rating',
    label: 'Avg Review Score',
    value: '4.9',
    subtext: 'All apartments',
    trend: '+0.1 vs last month',
    trendUp: true,
    icon: Star,
    iconBg: 'bg-accent/20',
    iconColor: 'text-amber-500',
    cardBg: 'bg-white',
    featured: false,
  },
  {
    id: 'kpi-guests',
    label: 'Total Guests YTD',
    value: '184',
    subtext: 'Jan – May 2026',
    trend: '+23% vs 2025',
    trendUp: true,
    icon: Users,
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600',
    cardBg: 'bg-white',
    featured: false,
  },
];

export default function DashboardKPIs() {
  return (
    // Grid plan: 6 cards → grid-cols-3 → row 1: featured spans 1 col + 2 regular, row 2: 3 regular
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-5">
      {kpis?.map((kpi) => {
        const IconComp = kpi?.icon;
        return (
          <div
            key={kpi?.id}
            className={`card-base p-5 border ${kpi?.cardBg} ${kpi?.featured ? 'ring-2 ring-primary/20' : ''}`}
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`w-10 h-10 rounded-xl ${kpi?.iconBg} flex items-center justify-center shrink-0`}>
                <IconComp size={20} className={kpi?.iconColor} />
              </div>
              {kpi?.alert && (
                <span className="text-[10px] font-700 uppercase tracking-wider bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
                  Action Needed
                </span>
              )}
            </div>
            <p className="text-[11px] font-700 uppercase tracking-wider text-muted-foreground mb-1">{kpi?.label}</p>
            <p className="text-3xl font-800 text-foreground tabular-nums mb-1">{kpi?.value}</p>
            <p className="text-xs text-muted-foreground mb-2">{kpi?.subtext}</p>
            <div className={`flex items-center gap-1 text-xs font-600 ${kpi?.trendUp ? 'text-green-600' : 'text-amber-600'}`}>
              {kpi?.trendUp ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
              {kpi?.trend}
            </div>
          </div>
        );
      })}
    </div>
  );
}